var render = function render(){var _vm=this,_c=_vm._self._c;return (!this.isLoading)?_c('h4',{style:({
  fontSize: _vm.size + 'px',
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  cursor: 'pointer',
  margin: 0,
  color: _vm.color
}),on:{"click":_vm.reload}},[(_vm.useIcon)?_c('b-img',{attrs:{"src":require('@/assets/images/ic_wallet.png'),"width":_vm.size * 1.5,"rounded":"circle","alt":"Circle image"}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.user.balance ? _vm.user.balance.toLocaleString() : 0)+" VNĐ")]),_c('svg',{staticClass:"lucide lucide-refresh-cw",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"}}),_c('path',{attrs:{"d":"M21 3v5h-5"}}),_c('path',{attrs:{"d":"M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"}}),_c('path',{attrs:{"d":"M8 16H3v5"}})])],1):_c('h4',{style:({
  fontSize: _vm.size + 'px',
  margin: 0,
  color: _vm.color
})},[_vm._v("Đang cập nhật ...")])
}
var staticRenderFns = []

export { render, staticRenderFns }